import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorListComponent } from './features/error-list/components/error-list/error-list.component';
import { ApiService } from './shared/services/api/api.service';
import { CommonService } from './shared/services/common/common.service';

@NgModule({
  imports: [CommonModule],
  declarations: [ErrorListComponent],
  providers: [ApiService, CommonService],
  exports: [ErrorListComponent],
})
export class SuvoCoreClientLibModule {}
